var _path, _path2, _rect, _path3, _polygon, _polygon2, _polygon3, _path4, _polygon4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon5, _polygon6, _circle, _path13, _path14, _path15, _path16, _polygon7, _polygon8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingWoman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 652,
    height: 570.12526,
    viewBox: "0 0 652 570.12526",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.95544,670.80537c-21.41987,11.54992-30.61494,36.063-30.61494,36.063s25.53333,5.787,46.95319-5.763,30.61493-36.063,30.61493-36.063S405.3753,659.25547,383.95544,670.80537Z",
    transform: "translate(-274 -164.93737)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391.00243,678.74409c-12.54547,20.85238-37.4643,28.88326-37.4643,28.88326s-4.57855-25.77746,7.96693-46.62985,37.46424-28.88328,37.46424-28.88328S403.54791,657.8917,391.00243,678.74409Z",
    transform: "translate(-274 -164.93737)",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 437.44488,
    y: 40.12526,
    width: 76,
    height: 45,
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M636.15176,212.3186h-39.1842V198.65473a19.5921,19.5921,0,0,1,39.1842,0Zm-38.31666-.86755h37.44912V198.65473a18.72456,18.72456,0,0,0-37.44912,0Z",
    transform: "translate(-274 -164.93737)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "381.527 45.502 381.527 40.162 281.877 42.832 278.723 178.092 293.471 196.31 381.527 45.502",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.167 43.622 291.158 46.08 293.471 196.31 397.705 185.075 399.167 43.622",
    fill: "#db3022"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "490.997 530.355 478.737 530.355 472.905 483.067 490.999 483.067 490.997 530.355",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M768.12328,707.17645l-39.53076-.00147v-.5A15.3873,15.3873,0,0,1,743.979,691.28875h.001l24.144.001Z",
    transform: "translate(-274 -164.93737)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.997 530.355 433.737 530.355 427.905 483.067 445.999 483.067 445.997 530.355",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M723.12328,707.17645l-39.53076-.00147v-.5A15.3873,15.3873,0,0,1,698.979,691.28875h.001l24.144.001Z",
    transform: "translate(-274 -164.93737)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M683.99246,399.19649s-17.91244,38.5748-1.73,116.22047,16.31629,162.88821,16.31629,162.88821l24.74368.40336,13.9-183.52L744.5,676.11766h24.378l21.48451-178.0691s14.13754-79.51349-17.39-93.74971Z",
    transform: "translate(-274 -164.93737)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M769.73255,263.06263,715.555,258.0685l0,0c-16.98986,12.38353-26.52543,34.62507-24.56793,57.57354,2.65407,31.11463,1.75616,73.93415-19.54217,92.53644,0,0,58.0494,45.8157,109.61509,2.34991,0,0-17.63267-47.23775-5.52651-66.10177S792.00719,272.56263,769.73255,263.06263Z",
    transform: "translate(-274 -164.93737)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M608.527,186.17919a10.7427,10.7427,0,0,0,11.43977,11.8524L691.5,264.78927l12.82084-19.52982-74.34632-59.47956a10.80091,10.80091,0,0,0-21.44756.3993Z",
    transform: "translate(-274 -164.93737)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M678.14208,254.47645l16.96983-17.43179a4.81689,4.81689,0,0,1,7.28075.438l14.712,19.2826a13.37737,13.37737,0,0,1-18.71875,19.11593l-19.61051-14.13836a4.81689,4.81689,0,0,1-.63333-7.26636Z",
    transform: "translate(-274 -164.93737)",
    fill: "#e4e4e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M874.28441,348.7493a10.74268,10.74268,0,0,0-12.08059-11.19852l-75.13166-62.68039-11.716,20.21194,77.536,55.25723a10.80091,10.80091,0,0,0,21.39225-1.59026Z",
    transform: "translate(-274 -164.93737)",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M800.98244,284.42515l-15.97515,18.34766a4.81688,4.81688,0,0,1-7.29384-.0328l-15.76058-18.43546a13.37737,13.37737,0,0,1,17.62782-20.12637l20.3657,13.027a4.81688,4.81688,0,0,1,1.03605,7.21995Z",
    transform: "translate(-274 -164.93737)",
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M881.9179,375.2531H852.237v-10.35a14.84048,14.84048,0,0,1,29.681,0Zm-29.02381-.65714h28.36666V364.9031a14.18333,14.18333,0,0,0-28.36666,0Z",
    transform: "translate(-274 -164.93737)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "622.594 208.892 622.594 204.847 547.112 206.87 544.723 309.325 555.894 323.125 622.594 208.892",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "635.956 207.468 554.142 209.33 555.894 323.125 634.849 314.615 635.956 207.468",
    fill: "#db3022"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 472.44488,
    cy: 52.12526,
    r: 32,
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M731.71177,202.80076c11.07,10.84841,30.33409,11.88815,42.50746,2.29425a71.78407,71.78407,0,0,1-15.288,67.676c6.77173,2.44676,14.56709.83705,20.61973-3.06277s10.53515-9.85419,13.91774-16.21037c8.37356-15.73462,10.4701-34.94725,4.54608-51.758s-20.11671-30.75035-37.3597-35.26409-37.01356,1.06186-48.53371,14.66262c-12.04649,14.22215-13.99821,35.06129-8.71923,52.93641s16.85751,33.22578,29.579,46.84748A195.4652,195.4652,0,0,1,720.926,232.02061c-.64717-5.73728-1.02538-11.65123.59548-17.19271s5.6099-10.70314,11.16965-12.26017",
    transform: "translate(-274 -164.93737)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M925,709.06263H544a1,1,0,0,1,0-2H925a1,1,0,0,1,0,2Z",
    transform: "translate(-274 -164.93737)",
    fill: "#cacaca"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M437,709.06263H275a1,1,0,0,1,0-2H437a1,1,0,0,1,0,2Z",
    transform: "translate(-274 -164.93737)",
    fill: "#cacaca"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M865.9179,622.2531H836.237v-10.35a14.84048,14.84048,0,0,1,29.681,0Zm-29.02381-.65714h28.36666V611.9031a14.18333,14.18333,0,0,0-28.36666,0Z",
    transform: "translate(-274 -164.93737)",
    fill: "#cacaca"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "606.594 455.892 606.594 451.847 531.112 453.87 528.723 556.325 539.894 570.125 606.594 455.892",
    fill: "#cacaca"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "619.956 454.468 538.142 456.33 539.894 570.125 618.849 561.615 619.956 454.468",
    fill: "#e4e4e4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingWoman);
export default __webpack_public_path__ + "static/media/shopping_woman.545cfec3c1aa9faf4fb4e94b1868adc5.svg";
export { ForwardRef as ReactComponent };